<template>
    <div class="row">

        <div class="col-md-12">
            <div class="tabs__filters d-flex">
                <tab-select @selectHook="getFacilitiesWithFilter" class="tabs__filters-item" :categories="selectCategory"/>
            </div>
        </div>

        <div class="col-md-12">
            <div class="tabs__content" :class="{'d-flex': !listNormalize.length || !loaded}">
                <div class="facility knowledge-base-update knowledge-base-update-empty" v-if="!loaded">
                    <div class="facility__profile-item knowledge-base-update__profile-item knowledge-base-update__profile-item-empty d-flex">

                        <div class="LoaderBalls">
                            <div class="LoaderBalls__item"></div>
                            <div class="LoaderBalls__item"></div>
                            <div class="LoaderBalls__item"></div>
                        </div>

                    </div>

                </div>
                <template v-else>
                    <div class="facility knowledge-base-update" v-if="listNormalize.length">
                        <div class="facility__profile-item knowledge-base-update__profile-item product product--tabs-row d-flex" v-for="(item, idx) in listNormalize" :key="idx">

                            <div class="facility__profile-left knowledge-base-update__profile-left">

                                <a class="facility__profile-image knowledge-base-update__profile-image" :href="`/volunteer/${user.id}/profile`">
                                    <img :src="`${user.avatar.replace('original', 'avatar')}`"  alt="user" v-if="user && user.avatar">
                                    <span v-text="getUserPM(user.name)"></span>
                                </a>

                            </div>
                            <div class="facility__profile-right knowledge-base-update__profile-right product-desc">

                                <div class="facility__profile-title knowledge-base-update__profile-title" v-text="item.name"></div>

                                <ul class="facility__profile-info knowledge-base-update__profile-info">

                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">{{$store.getters.t('facilities_filter_tariff')}} </span>{{item.chargeDescr}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">{{$store.getters.t('facilities_store_form_availability')}} </span>{{!item.arr.length ? item.rangeDescr : item.arr}}
                                    </li>

                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">{{$store.getters.t('facilities_store_form_service_type')}} </span>{{item.typeDescr}}
                                    </li>


                                    <template v-if="item.images.length">
                                        <li class="facility__profile-info-item knowledge-base-update__profile-info-item">
                                            <span class="facility__profile-info-label knowledge-base-update__profile-info-label">{{$store.getters.t('common_photos')}}: </span>
                                            <div class="card-horizontal__user-info-photos d-flex">
                                                <a :href="`/storage${image.path}`" v-for="(image, idx) in item.images"
                                                   :data-lightbox="'facility-' + item.id" :style="{backgroundImage: image.path ? `url( /storage/${image.path.replace('original', 'preview_l')} )` : 'none'}"></a>
                                            </div>
                                        </li>
                                    </template>

                                </ul>

                                <div class="facility__profile-description knowledge-base-update__profile-description" v-text="item.description"></div>



                                <div class="knowledge-base__nav d-flex" v-if="(user) ?  (+item.user_id === +user.id) : false">

                                    <a class="btn btn-sm btn--round" :href="`/publication/facility/${item.id}`">
                                        {{$store.getters.t('common_edit')}}
                                    </a>
                                    <a class="btn btn-sm btn--round" :style="{background: '#0674ec'}" href="#"
                                       @click.prevent="deleteItem(item.id, item.type)">
                                        {{$store.getters.t('common_delete')}}
                                    </a>

                                </div>

                            </div>


                            <transition name="slide">
                                <store-form :updateOBJ="item" @updateForm="refreshPage"
                                            type="UPDATE" :page-type="item.type === 'auto_help' ? 'auto-help' : item.type === 'giveaway' ? 'giveaway' :'photo-n-pr'"
                                            v-if="selectedItem === item.id"/>
                            </transition>



                        </div>




                    </div>

                    <div class="facility knowledge-base-update knowledge-base-update-empty"  v-else>
                        <div class="facility__profile-item knowledge-base-update__profile-item knowledge-base-update__profile-item-empty d-flex">

                            {{$store.getters.t('facilities_list_empty')}}

                        </div>
                    </div>





                </template>


            </div>
        </div>

        <div class="col-md-12" v-if="pageCount > 1">
            <div class="pagination-area">
                <nav class="navigation pagination" role="navigation">
                    <div class="nav-links">
                        <paginate
                            v-model="page"
                            :page-count="pageCount"
                            :click-handler="paginateClickCallback"
                            :prev-text="''"
                            :next-text="''"
                            :container-class="'className'"
                            :page-class="'page-numbers'"
                            :page-link-class="''"
                            :active-class="'current'"
                            :prev-class="'prev page-numbers'"
                            :prev-link-class="'lnr lnr-arrow-left'"
                            :next-class="'next page-numbers'"
                            :next-link-class="'lnr lnr-arrow-right'"
                        >
                        </paginate>
                    </div>
                </nav>
            </div>
        </div>

    </div>
</template>

<script>

import StoreForm from "../../../Facilities/StoreForm";
import TabSelect from "../TabSelect";

export default {
    name: "TabFacilities",
    props:['selectCategory'],
    components:{
        StoreForm,
        TabSelect
    },
    data(){
        return{
            list: [],
            pageCount: 0,
            page: 1,
            selectedItem: null,
            loaded: true,

            facilitiesType: []
        }
    },
    mounted(){
        this.loaded = false
        this.getMyFacilities()
    },

    watch:{
        list(){
            this.loaded = false
            setTimeout(()=>{
                this.loaded = true
            }, 1000)
        }
    },

    computed:{

        user(){
            return this.$store.getters.getUserData;
        },


        listNormalize(){
            if(!this.list.length) return []

           return this.list.map((element) => {

               element.arr = [...element.cities,...element.regions]
               element.typeDescr = ''
               element.rangeDescr = ''
               element.chargeDescr = ''

                switch (element.type){
                    case 'photo_help':
                        element.typeDescr = this.$store.getters.t('facilities_store_form_photo_help')
                        break;
                    case 'pr_help':
                        element.typeDescr = this.$store.getters.t('facilities_store_form_pr')
                        break;
                    case 'auto_help':
                        element.typeDescr = this.$store.getters.t('facilities_store_form_auto_help')
                        break;
                    case 'giveaway':
                        element.typeDescr = this.$store.getters.t('facilities_store_form_giveaway')
                        break;
                    default:
                        element.typeDescr = ''
                }


                switch (element.range){
                    case 'city':
                    case 'region':
                        element.arr = element.arr.map(item => item.name).join(', ')
                        break;
                    case 'country':
                        element.rangeDescr = this.$store.getters.t('facilities_card_range_country')
                        break;
                    case 'abroads':
                        element.rangeDescr = this.$store.getters.t('facilities_card_range_abroads')
                        break;
                    default:
                        element.rangeDescr = ''
                }

                switch (element.charge_category){
                    case 'free':
                        element.chargeDescr = this.$store.getters.t('facilities_store_form_free')
                        break;
                    case 'paid_for':
                        element.chargeDescr = this.$store.getters.t('facilities_store_form_paid')
                        break;
                    case 'cost_recovery':
                        element.chargeDescr = this.$store.getters.t('facilities_store_form_cost_recovery')
                        break;
                    default:
                        element.chargeDescr = ''
                }


                return element

            })

        },

    },
    methods:{

        getFacilitiesWithFilter(item){
            this.selectedItem = null
            this.facilitiesType = []
            this.facilitiesType.push(item.id)
            this.getMyFacilities()
        },

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

        paginateClickCallback(pageNum) {
            this.page = pageNum;
            this.getMyFacilities();
        },

        refreshPage(){
            this.facilitiesType = []
            this.getMyFacilities()
        },

        deleteItem(idx, type){

            if(!type || !idx) return

            switch (type){
                case 'photo_help':
                    type = 'photo-help'
                    break;
                case 'pr_help':
                    type = 'pr-help'
                    break;
                case 'auto_help':
                    type = 'auto-help'
                    break;
                case 'giveaway':
                    type = 'giveaway'
                    break;
                default:
                    type = ''
            }


            let  url = `/api/facilities/${type}/${idx}`

            axios.delete(url)
                .then(response => {
                    response = response.data

                    if(response.success){

                        console.log('deleted')

                    }

                })
                .catch(error => {
                    error = error.response.data

                    console.log(error)

                })
                .then(() => {
                    this.getMyFacilities()
                })

        },

        getMyFacilities(){

            if(!this.user) return


            let url = `/api/user/facilities`

            axios.get(url,{
                params: {
                    types: this.facilitiesType.length ? this.facilitiesType : null,
                    page: this.page,
                    per_page: 5,
                }
            })
                .then((response) => {

                    response = response.data

                    if(response.success){
                        this.list = response.data
                        this.page = response.meta.current_page
                        this.pageCount = response.meta.last_page
                    }

                })
                .catch((error) => {
                    error = error.response.data
                    console.log(error)
                })


        },


        openForm(idx){

            if(this.selectedItem === idx) return this.selectedItem = null

            return this.selectedItem = idx
        }
    }

}
</script>

<style lang="scss" scoped>

    .slide-enter-active {
        -moz-transition-duration: 0.4s;
        -webkit-transition-duration: 0.4s;
        -o-transition-duration: 0.4s;
        transition-duration: 0.4s;
        -moz-transition-timing-function: ease;
        -webkit-transition-timing-function: ease;
        -o-transition-timing-function: ease;
        transition-timing-function: ease;
    }

    .slide-leave-active {
        -moz-transition-duration: 0.4s;
        -webkit-transition-duration: 0.4s;
        -o-transition-duration: 0.4s;
        transition-duration: 0.4s;
        -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    }

    .slide-enter-to, .slide-leave {
        max-height: 1000px;
        overflow: hidden;
    }

    .slide-enter, .slide-leave-to {
        overflow: hidden;
        max-height: 0;
    }


</style>
